import { configureStore } from "@reduxjs/toolkit"
import Global from './data/global'

const store = configureStore({
    reducer:{
        Global
    }
})



export default store